export var VERSION = "1.6.0";
//# sourceMappingURL=version.js.map